import UserAccountForm from './user-account-form'

export default UserAccountForm;